import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import {Match} from '../../models'
import template from './event-submitter.jade'
import '@scoutgg/ftw/source/atoms/toggle/toggle'
import '@scoutgg/ftw/source/atoms/button/button'
import '@scoutgg/ftw/source/atoms/icons/icons'
import shortcuts from '../../services/shortcuts'
import getState from '../../services/event-state'

@Component('sporty')
@Template(template)
@Attribute('match', Match)
export default class EventSubmitter extends HTMLElement {
  matchChange() {
    this.state.listen(this)
  }
  assignMinute(n, r) {
    if(this.minuteNeedsConversion) {
      const round = r || this.state.round
      this.state
        .assignMinute(
           +n +
          (+round * 10) +
          this.state.event.batch * 1000
        )
    } else if(this.isBatched) {
      this.state.assignMinute((+n + (this.state.event.batch || 0) * 1000))
    } else {
      this.state.assignMinute(+n)
    }
  }
  assignSecond(n) {
    this.state.assignSecond(+n)
    if(this.match.sport === 'csgo') {
      this.assignMillisecond()
    }
  }

  adjustMinute(n) {
    const round = n ? n : this.state.round
    this.assignMinute(0, round)
  }
  assignMillisecond() {
    this.state.assignMillisecond()
  }

  assignBatch(n) {
    this.state.assignBatch(+n)
  }
  assignDuration(n) {
    this.state.assignDuration(+n)
  }
  attached() {
    getState(this.match).listen(this)
    this.on('input')
    this.cancelSubTypes = shortcuts(this.shortcuts, (key) => {
      var subType = this.subTypes[this.shortcuts.indexOf(key)]
      this.selectSubType(subType)
    })
    this.cancelMinutes = shortcuts(['m'], (key, n) => {
      this.assignMinute(n)
    })
    this.cancelSeconds = shortcuts(['n'], (key, n) => {
      this.assignSecond(n)
    })
    this.cancelPenalty = shortcuts(['b'], (key, n) => {
      this.assignDuration(n)
    })
    var submit = this.submit.bind(this)
    this.cancelSubmit = shortcuts.direct(13, submit) // Return key
  }
  detached() {
    if(this.cancelSubTypes) this.cancelSubTypes()
    if(this.cancelPenalty) this.cancelPenalty()
    if(this.cancelMinutes) this.cancelMinutes()
    if(this.cancelSeconds) this.cancelSeconds()
    if(this.cancelSubmit) this.cancelSubmit()
  }
  submit() {
    this.state.submit()
  }
  roundStart(round) {
    return this.state.roundStart(round)
  }
  roundEnd(round) {
    return this.state.roundEnd(round)
  }
  roundLabel(round) {
    if(isNaN(round)) return round
    return `Round ${round}`
  }
  selectSubType(type) {
    this.event.subType = type
    this.state.render()
  }
  changeName(name) {
    this.state.changeName(name)
    this.state.render()
  }
  get displayMinute() {
    const periods = this.match?.rules?.hasTag('periods')
    if(periods) return (minute, start, round) => `${round} - ${minute - start}`
    return minute => minute
  }
  get sport() {
    return this.match && this.match.sport
  }
  get subTypes() {
    return this.state.subTypes
  }
  get state() {
    return getState(this.match)
  }
  get event() {
    return getState(this.match).event
  }
  get player() {
    var lineup = this.state.player
    return lineup && lineup.player
  }
  get subPlayer() {
    var lineup = this.state.subPlayer
    return lineup && lineup.player
  }
  get rounds() {
    return this.state.rounds
  }
  get isReady() {
    return this.state.isReady
  }
  get shortcuts() {
    return 'zxcvb'.split('')
  }
  get isBonus() {
    return /bonus/.exec(this.event)
  }
  get canSubPlayer() {
    return this.state.canSubPlayer
  }
  get minute() {
    if(this.minuteNeedsConversion) {
      if(!this.state.event.minute) return 0
      return ((this.state.event.minute % 1000) % 10)
    }
    if(this.isBatched) {
      return (this.state.event.minute % 1000)
    }
    return this.state.event.minute || 1
  }
  get second() {
    return this.state.event.second || 0
  }

  get batch() {
    return this.state.event.batch || 0
  }
  get minuteNeedsConversion() {
    return this.sport === 'csgo'
  }
  get durations() {
    return this.state.durations
  }
  get minuteLabel() {
    if(this.sport === 'curling') return 'End'
    return 'Minute'
  }
  batchRound(event) {
    return this.state.round
  }

  get isSeconds() {
    return ![
      'curling',
    ].includes(this.sport)
  }
  get isPreMatch() {
    return ![
      'curling',
    ].includes(this.sport)
  }

  get isBatched() {
    return this.match.locations && this.match.locations.length
  }
  get durationLabel() {
    if(this.sport === 'curling') return 'Points'
    if(this.sport === 'cricket') return 'Runs'
    return 'Duration'
  }
  get lastMinute() {
    return this.state.lastMinute
  }
}
